/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import ConvocationResignation from '../model/ConvocationResignation';
import ConvocationResignationEligibleAcademicProgram from '../model/ConvocationResignationEligibleAcademicProgram';
import ConvocationResignationProcess from '../model/ConvocationResignationProcess';
import Error from '../model/Error';

/**
* ConvocationResignations service.
* @module api/ConvocationResignationsApi
* @version 1.0.0
*/
export default class ConvocationResignationsApi {

    /**
    * Constructs a new ConvocationResignationsApi. 
    * @alias module:api/ConvocationResignationsApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * Create Convocation Resignation Request
     * Create a new convocation resignation request for an academic program.
     * @param {Number} academicProgramId The academic program id.
     * @param {Array.<File>} justifyingDocs The justifying documentation that prove the reasons why the student needs to resign to the convocations.
     * @param {File} annexDoc The official annex document filled by the student.
     * @param {String} comment The student reason of the resignation request.
     * @param {Object} opts Optional parameters
     * @param {Array.<Number>} opts.ordinaryResignationEnrollIds The enroll ids which are requested for an ordinary convocation resignation.
     * @param {Array.<Number>} opts.extraordinaryResignationEnrollIds The enroll ids which are requested for an extraordinary convocation resignation.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ConvocationResignation} and HTTP response
     */
    convocationResignationsAcademicProgramsAcademicProgramIdPostWithHttpInfo(academicProgramId, justifyingDocs, annexDoc, comment, opts) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'academicProgramId' is set
      if (academicProgramId === undefined || academicProgramId === null) {
        throw new Error("Missing the required parameter 'academicProgramId' when calling convocationResignationsAcademicProgramsAcademicProgramIdPost");
      }
      // verify the required parameter 'justifyingDocs' is set
      if (justifyingDocs === undefined || justifyingDocs === null) {
        throw new Error("Missing the required parameter 'justifyingDocs' when calling convocationResignationsAcademicProgramsAcademicProgramIdPost");
      }
      // verify the required parameter 'annexDoc' is set
      if (annexDoc === undefined || annexDoc === null) {
        throw new Error("Missing the required parameter 'annexDoc' when calling convocationResignationsAcademicProgramsAcademicProgramIdPost");
      }
      // verify the required parameter 'comment' is set
      if (comment === undefined || comment === null) {
        throw new Error("Missing the required parameter 'comment' when calling convocationResignationsAcademicProgramsAcademicProgramIdPost");
      }

      let pathParams = {
        'academic_program_id': academicProgramId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'ordinary_resignation_enroll_ids': this.apiClient.buildCollectionParam(opts['ordinaryResignationEnrollIds'], 'csv'),
        'extraordinary_resignation_enroll_ids': this.apiClient.buildCollectionParam(opts['extraordinaryResignationEnrollIds'], 'csv'),
        'justifying_docs': this.apiClient.buildCollectionParam(justifyingDocs, 'csv'),
        'annex_doc': annexDoc,
        'comment': comment
      };

      let authNames = [];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['application/json'];
      let returnType = ConvocationResignation;
      return this.apiClient.callApi(
        '/convocation-resignations/academic-programs/{academic_program_id}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Create Convocation Resignation Request
     * Create a new convocation resignation request for an academic program.
     * @param {Number} academicProgramId The academic program id.
     * @param {Array.<File>} justifyingDocs The justifying documentation that prove the reasons why the student needs to resign to the convocations.
     * @param {File} annexDoc The official annex document filled by the student.
     * @param {String} comment The student reason of the resignation request.
     * @param {Object} opts Optional parameters
     * @param {Array.<Number>} opts.ordinaryResignationEnrollIds The enroll ids which are requested for an ordinary convocation resignation.
     * @param {Array.<Number>} opts.extraordinaryResignationEnrollIds The enroll ids which are requested for an extraordinary convocation resignation.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ConvocationResignation}
     */
    convocationResignationsAcademicProgramsAcademicProgramIdPost(academicProgramId, justifyingDocs, annexDoc, comment, opts) {
      return this.convocationResignationsAcademicProgramsAcademicProgramIdPostWithHttpInfo(academicProgramId, justifyingDocs, annexDoc, comment, opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Get Resignable Academic Programs
     * Get the academic programs together with the formative actions that are eligible for the current convocation resignation active process and the requesting student.
     * @param {Object} opts Optional parameters
     * @param {String} opts.locale The student locale code to translate the resource.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/ConvocationResignationEligibleAcademicProgram>} and HTTP response
     */
    convocationResignationsAcademicProgramsGetWithHttpInfo(opts) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
        'locale': opts['locale']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [ConvocationResignationEligibleAcademicProgram];
      return this.apiClient.callApi(
        '/convocation-resignations/academic-programs', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Get Resignable Academic Programs
     * Get the academic programs together with the formative actions that are eligible for the current convocation resignation active process and the requesting student.
     * @param {Object} opts Optional parameters
     * @param {String} opts.locale The student locale code to translate the resource.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/ConvocationResignationEligibleAcademicProgram>}
     */
    convocationResignationsAcademicProgramsGet(opts) {
      return this.convocationResignationsAcademicProgramsGetWithHttpInfo(opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Get Current Convocation Resignation Active Process
     * Get the current active convocation resignation process, if exists any for the requesting student.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ConvocationResignationProcess} and HTTP response
     */
    convocationResignationsActiveProcessGetWithHttpInfo() {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = ConvocationResignationProcess;
      return this.apiClient.callApi(
        '/convocation-resignations/active-process', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Get Current Convocation Resignation Active Process
     * Get the current active convocation resignation process, if exists any for the requesting student.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ConvocationResignationProcess}
     */
    convocationResignationsActiveProcessGet() {
      return this.convocationResignationsActiveProcessGetWithHttpInfo()
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


    /**
     * Download Convocation Resignation Annex
     * Download the annex that the student needs to fill and upload in order to submit the convocation resignation request.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link File} and HTTP response
     */
    convocationResignationsAnnexGetWithHttpInfo() {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/pdf', 'application/json'];
      let returnType = File;
      return this.apiClient.callApi(
        '/convocation-resignations/annex', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Download Convocation Resignation Annex
     * Download the annex that the student needs to fill and upload in order to submit the convocation resignation request.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link File}
     */
    convocationResignationsAnnexGet() {
      return this.convocationResignationsAnnexGetWithHttpInfo()
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
